[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 5,
                "y": 6,
                "key": "tCV9X"
            },
            {
                "x": 7,
                "y": 6,
                "key": "9iyjQ"
            },
            {
                "x": 7,
                "y": 5,
                "key": "ulIc6"
            },
            {
                "x": 5,
                "y": 5,
                "key": "OInZX"
            },
            {
                "x": 5,
                "y": 3,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 11,
                "y": 3,
                "key": "7gTwWqlCkIq9wxOI9wDMl"
            },
            {
                "x": 11,
                "y": 5,
                "key": "tIMqe"
            },
            {
                "x": 9,
                "y": 5,
                "key": "wQNin"
            },
            {
                "x": 9,
                "y": 6,
                "key": "koK4t"
            },
            {
                "x": 11,
                "y": 6,
                "key": "tk6Oe"
            },
            {
                "x": 11,
                "y": 8,
                "key": "z9Nn61pWmpd489F0Co-yj"
            },
            {
                "x": 5,
                "y": 8,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    }
]